import { render, staticRenderFns } from "./RankingPage.vue?vue&type=template&id=c42960aa"
import script from "./RankingPage.vue?vue&type=script&lang=ts"
export * from "./RankingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports